import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"
import { Icon } from "@blueprintjs/core"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

export const SideContentContainer = styled(FlexContainer)({
  width: "100%",
  padding: "10px",
  flex: "0 0 25%",
  overflow: "auto",
  backgroundColor: SCIENT_COLORS.darkGray5,
})
